import { Flex, Text } from "styles/utility-components";

import { SavedViewForm } from "components/my_feed/views_bar/SavedViewForm";
import Modal from "components/ui/modal/Modal";

type SaveViewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  saveView: (view: {
    viewName: string;
    viewDescription: string;
    alertFrequency: "DAILY" | "WEEKLY" | "NEVER";
  }) => void;
};

export function SaveViewModal({ isOpen, onClose, saveView }: SaveViewModalProps) {
  return (
    <Modal open={isOpen} onOpenChange={onClose}>
      <Flex column>
        <Text h1>Save view</Text>
        <Text>
          Quickly access your most commonly used filters at anytime by creating filtered views.
        </Text>
        <SavedViewForm
          defaultValues={{
            viewName: "",
            viewDescription: "",
            alertFrequency: "DAILY",
          }}
          onSubmit={({ viewName, viewDescription, alertFrequency }) => {
            saveView({ viewName, viewDescription, alertFrequency: alertFrequency || "NEVER" });
          }}
          onCancel={() => {
            onClose();
          }}
        />
      </Flex>
    </Modal>
  );
}
